import * as React from "react";
import Moment from 'react-moment';

class Users extends React.Component<any,any> {
    renderUser(user) {
        let userName;
        if(user.name) {
            userName = user.name + " (" + user.email + ")";
        } else {
            userName = user.email;
        }

        let avatar;
        if (user.image_src) {
            avatar = <img alt="" className="user-image" src={user.image_src} />;
        } else {
            avatar = "";
        }
        let lastMessage;
        let messageCount = this.props.messages.reduce((acc,message) => {            
            if(message.senderId === user.id)  {
                lastMessage = message;
                return (acc + 1);
            } else {
                return acc;
            }
        },0);
        let lastMessageDate;
        if(lastMessage) {
            lastMessageDate =
                <div className="user-info">
                    Last message: &nbsp;
                    <Moment format="DD/MM/YYYY HH:mm:ss">
                        {lastMessage.createdAt}
                    </Moment>
                </div>;
        }
        return (
            <div className="user-container" key={user.id}>
                <div className="user">
                    {avatar}
                    <span><a target="_blank" href={"/documents/user/" + user.id + ".html"}>{userName}</a></span>
                    <div className="user-info">Messages: {messageCount} </div>
                    {lastMessageDate}
                </div>
            </div>
        )
    }
    render() {
        const {users} = this.props;                

        let usersInfo: any[] = [];
        
        for (let userId in users) {
            if (users.hasOwnProperty(userId)) {
                usersInfo.push(users[userId]);
            }
        }

        let messagesCount = this.props.messages.length;
        return (
            <div className="header">
                <div>
                    {usersInfo.map((user)=> this.renderUser(user))}
                </div>
            </div>
        );
    }
}

export default Users;
